import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container, Avatar } from '@mui/material';
import { useNavigate, Outlet } from 'react-router-dom';

export default function EmployeeLayout({ children }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('employee_access_token');
    localStorage.removeItem('employee_refresh_token');
    localStorage.removeItem('employee_user');
    navigate('/employee/login');
  };

  const employeeUser = JSON.parse(localStorage.getItem('employee_user') || '{}');
  const displayName = employeeUser.name || employeeUser.email || 'Employee';

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <AppBar position="static" sx={{ bgcolor: '#bfa074' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700, letterSpacing: 1 }}>
            BunnyRent Staff Portal
          </Typography>
          <Button color="inherit" onClick={() => navigate('/employee/progress-overview')}>Status</Button>
          <Button color="inherit" onClick={() => navigate('/employee/complete')}>Complete</Button>
          <Button color="inherit" onClick={handleLogout}>Logout</Button>
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 2 }}>
            <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
              {displayName[0]}
            </Avatar>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>{displayName}</Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <Container maxWidth="xl" sx={{ py: 4, px: 3, bgcolor: '#f5f5f5' }}>
        <Outlet />
      </Container>
    </Box>
  );
} 